import { Text } from "@utils/helper";
import { buildClass } from "@utils/tag";
import useTranslation from "next-translate/useTranslation";
import { useSelector } from "noval";
import Link from "next/link";
import CustomImage from "@components/CustomImage";
import { Skeleton } from "@mui/material";

export const memberships = {
  1: "/images/global/regular.png",
  2: "/images/global/gold.png",
  3: "/images/global/diamond-icon.png",
};

const ProfileCard = () => {
  const user = useSelector("user");
  const { t } = useTranslation("my-account");

  const current_membership = user?.membership?.current;
  const membership_icon = memberships?.[current_membership || 1];
  const isProfessional = (user?.upgrade_request_level?.value || 1) === 2;

  return (
    <Link
      href="/my-profile"
      className={buildClass(
        "flex items-center gap-[24px] w-full sm:w-[500px]",
        "bg-[#FFFFFF] p-[26px] rounded-[20px] h-[161px]",
        "flex-row mx-auto sm:mx-0 shadow-[0px_40px_30px_-25px_#00000008]"
      )}
    >
      <CustomImage
        src={membership_icon}
        alt={t("membership_type")}
        className="w-[100px] h-[100px] rounded-full"
        style={{ boxShadow: "0px 0px 1px #0000001a" }}
        width={150}
        height={150}
      />
      {!user && (
        <div className="flex flex-col gap-1 w-full">
          <Skeleton
            animation="wave"
            height={20}
            width="90%"
            sx={{ bgcolor: "rgba(255,255,255,0.7)" }}
          />
          <Skeleton
            animation="wave"
            height={20}
            width="70%"
            sx={{ bgcolor: "rgba(255,255,255,0.7)" }}
          />
        </div>
      )}
      {user && (
        <div className="md:w-[324px] flex flex-col gap-2">
          <Text
            size="34px"
            fontType="Expo_sim"
            weight={500}
            className="leading-[41px]"
          >
            {user?.first_name} {user?.last_name}
          </Text>
          <Text
            fontType="Expo_bok"
            weight={400}
            className="leading-[21px]"
            color="#8F8F8F"
          >
            {user?.email}
          </Text>

          {isProfessional && (
            <Text
              fontType="Expo_bok"
              weight={400}
              size={14}
              color="#FFFFFF"
              className="bg-[#0366FF] rounded-[50px] px-3 py-1.5 w-fit"
            >
              {t("qualified_investor")}
            </Text>
          )}
        </div>
      )}
    </Link>
  );
};

export default ProfileCard;
